class Configuration {
  constructor(data) {
    _.merge(this, data);
  }
}

export default Configuration;



// WEBPACK FOOTER //
// ./client/domain/configuration.js